import { makeStyles } from '@material-ui/core/styles';

import theme from '../../../../theme';

export const useStyles = makeStyles(() => ({
    tooltip: {
        fontSize: '14px',
        padding: '12px 16px',
        maxWidth: '500px'
    },
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#111218',
        padding: '0 20px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: '16px'
        },
        '& .work-instructions-btn': {
            backgroundColor: 'rgba(255, 220, 168, 0.1)',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '0 8px',
            height: '40px',
            marginLeft: 0,
            '& .work-instructions-actions': {
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                marginLeft: '12px'
            }
        }, 
        '& .work-in-progress-btn': {
            backgroundColor: 'rgba(255, 220, 168, 0.1)',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '0 8px',
            height: '40px',
            marginLeft: 0,
            '& .clock-icon': {
                marginRight: '2px'
            },
            '& .work-in-progress-actions': {
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                marginLeft: '12px'
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                maxWidth: '100%',
                marginLeft: 0,
                marginTop: '12px'
            }
        },
        '& .questions-btn': {
            backgroundColor: 'rgba(255, 220, 168, 0.1)',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            width: '180px',
            height: '40px',
            marginLeft: 0,
            marginRight: 5,
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                maxWidth: '100%',
                marginLeft: 0,
                marginTop: '12px'
            }
        },
        '& .launch-extension-btn': {
            backgroundColor: 'rgba(255, 220, 168, 0.1)',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            maxWidth: '250px',
            width: '250px',
            height: '40px',
            marginLeft: 0,
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                maxWidth: '100%',
                marginLeft: 0,
                marginTop: '12px'
            }
        },
        '& .report-blocker-btn': {
            backgroundColor: 'rgba(255, 220, 168, 0.1)',
            borderRadius: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            minWidth: '40px',
            padding: 0,
            marginLeft: 0,
            [theme.breakpoints.down('sm')]: {
                marginTop: '12px'
            }
        },
        '& .action-icon-btn': {
            backgroundColor: 'transparent',
            borderRadius: '100px',
            width: '40px',
            height: '40px',
            minWidth: '40px',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
                backgroundColor: 'rgba(255, 220, 168, 0.2)'
            },
            '& img': {
                width: '20px',
                height: '20px'
            },
            '& svg': {
                width: '20px',
                height: '20px'
            }
        }
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        gap: '20px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            width: '100%',
            gap: 0
        }
    },
    titleWithActions: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flex: '1 1 auto',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '12px'
        }
    },
    title: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '19.36px',
        color: 'rgba(255, 255, 255, 0.9)',
        marginLeft: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 'calc(100% - 800px)',
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginBottom: 0,
            width: '100%'
        }
    },
    actionIcons: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        [theme.breakpoints.down('sm')]: {
            marginTop: '12px',
            width: '100%',
            justifyContent: 'flex-start'
        }
    },
    workInProgressText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '12px',
        color: 'rgba(255, 255, 255, 0.6)'
    },
    workInstructionsText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '12px',
        color: 'rgba(255, 255, 255, 0.6)',
        paddingLeft: '10px'
    },
    cancelText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '12px',
        color: 'rgba(250, 187, 24, 0.6)'
    },
    questionsText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '23px',
        color: 'rgba(250, 187, 24, 0.8)'
    },
    extensionLink: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
    },
    launchExtensionText: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '12px',
        color: 'rgba(255, 255, 255, 0.6)'
    },
    discussionNotification: {
        position: 'absolute',
        top: '8px',
        right: '9px',
        width: '10px',
        height: '10px',
        color: theme.palette.error.main
    },
    workInstructionsBox: {
        backgroundColor: 'rgba(255, 220, 168, 0.1)',
        borderRadius: '100px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0 8px',
        height: '40px',
        marginLeft: 0,
        '& .work-instructions-actions': {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            marginLeft: '12px'
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: '100%',
            marginLeft: 0,
            marginTop: '12px'
        }
    }
}));
